import WideSecureLayout from "../../../../layout/WideSecureLayout.jsx";
import React from "react";
import DashboardGrid from "../../../../components/dashboard/DashboardGrid.jsx";
import DashboardFilterContextProvider from "../../../../components/filters/DashboardFilterContextProvider.jsx";
import LeadDashboardFilters from "./LeadDashboardFilters.jsx";

export default function LeadDashboardLayout({title, children, hideSourceFilter, hideCampaignFilter}) {
    // noinspection JSValidateTypes
    return <WideSecureLayout title={title} actions={
        <
            LeadDashboardFilters
            hideSourceFilter={hideSourceFilter}
            hideCampaignFilter={hideCampaignFilter}
        />
    }>
            <DashboardGrid>
                {children}
            </DashboardGrid>
        </WideSecureLayout>;
}
